export namespace ProfileTranslations {
  export const locale = {
    locale: 'locale',
    selectLocale: 'selectLocale',
  } as const;

  export const changePassword = {
    changePasswordSectionTitle: 'changePasswordSectionTitle',
    changePasswordSectionSubtitle: 'changePasswordSectionSubtitle',
    changePasswordCurrentPassword: 'changePasswordCurrentPassword',
    changePasswordNewPassword: 'changePasswordNewPassword',
    changePasswordSuccessTitle: 'changePasswordSuccessTitle',
  } as const;
}
